import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { KeyValueForm } from './httpForm';
import { TranslatePipe } from '@ngx-translate/core';
import {
  AppDialogRef,
  AppDialogService,
} from '@nimmsta/ng-commons-lib/services/app-dialog';
import { InputWithErrorComponent } from '@nimmsta/ng-commons-lib/forms';

@Component({
  selector: 'app-key-value-form',
  templateUrl: './keyValueForm.component.html',
  imports: [TranslatePipe, TranslatePipe, InputWithErrorComponent],
})
export class KeyValueFormComponent {
  modalService = inject(AppDialogService);

  title!: string;

  description?: string;

  form?: FormArray<FormGroup<KeyValueForm>>;

  private startValue?: { key: string; value: string }[];

  private modalRef!: AppDialogRef;

  @ViewChild('modal', { static: true }) modal!: TemplateRef<unknown>;

  show(
    title: string,
    form: FormArray<FormGroup<KeyValueForm>>,
    description = '',
  ): void {
    this.title = title;
    this.description = description;
    this.form = form;
    this.startValue = this.form?.value.map((v) => ({
      key: v.key,
      value: v.value,
    }));
    this.modalRef = this.modalService.open(this.modal, { size: 'lg' });
  }

  remove(index: number): void {
    this.form!.removeAt(index);
    this.form!.markAsDirty();
  }

  add(): void {
    this.form!.push(
      new FormGroup<KeyValueForm>({
        key: new FormControl('', [Validators.required]),
        value: new FormControl('', [Validators.required]),
      }),
    );
  }

  save(): void {
    this.modalRef.close();
  }

  cancel(): void {
    this.modalRef.close();
    if (this.form!.value.length > this.startValue!.length) {
      // Remove forms if startValue has less elements than form
      for (let i = this.form!.value.length; i > this.startValue!.length; i--) {
        this.form!.removeAt(i - 1);
      }
    } else if (this.form!.value.length < this.startValue!.length) {
      // Fill in missing forms if startValue has more elements than form
      for (let i = this.startValue!.length; i > this.form!.value.length; i--) {
        this.add();
      }
    }
    this.form?.setValue(this.startValue!);
    this.form?.markAsPristine();
  }
}
